import { configureStore } from "@reduxjs/toolkit";

import appReducer from "./Reducers/appReducer";

export const store = configureStore({
  reducer: {
    app: appReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
